<template>
<div>
    <!-- table -->
    <vue-good-table id="lawClientAccountingLedesTable" ref="lawClientAccountingLedesTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'lawInvoiceNo'" class="text-nowrap">
                {{ $t('lawClientAccountingLedes.law_invoice_no') }}
            </span>
            <span v-else-if="props.column.field === 'lawClientAccountingNo'" class="text-nowrap">
                {{ $t('lawClientAccountingLedes.law_client_accounting_no') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Process -->
            <span v-if="props.column.field === 'process'">
                <span>
                    <b-button v-b-tooltip.html :title="$t('others.download')" variant="outline-primary" class="btn-icon mb-1 ml-1" size="sm" @click="downloadLawClientAccountingLedes(props.row.id)">
                        <feather-icon icon="DownloadIcon" />
                    </b-button>
                </span>
            </span>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    props: {
        getClientsList: {
            type: Function
        },
        clientId: {
            type: Number
        },
    },
    data() {
        return {
            pageLength: 10,
            dir: false,
            lawClientAccountingLedesList: '',
            columns: [{
                    label: this.$t('lawClientAccountingLedes.law_invoice_no'),
                    field: `lawInvoiceNo`,
                },
                {
                    label: this.$t('lawClientAccountingLedes.law_client_accounting_no'),
                    field: `lawClientAccountingNo`,
                },
                {
                    label: this.$t('lawClientAccountingLedes.update_date'),
                    field: `updateDate`,
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('lawClientAccountingLedes.record_date'),
                    field: `recordDate`,
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('lawClientAccountingLedes.employee'),
                    field: `employee`,
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '10em'
                },
            ],
            rows: [],
            searchTerm: '',
        }
    },
    mounted() {
        this.getLawClientAccountingLedesList()
    },
    methods: {
        async getInfo(id) {
            this.$refs.lawClientAccountingLedesFormModal.showInfo(id, this.clientId)
        },
        getLawClientAccountingLedesList() {
            this.rows = []
            const data = {
                id: this.clientId
            }
            const controller = {
                name: 'LawClientAccountingLedes',
                actionName: 'GetLawClientAccountingLedesListByLawClientId'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.rows = response.data.lawClientAccountingLedesList
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        downloadLawClientAccountingLedes(id) {
            const data = {
                id: id
            }
            const controller = {
                name: 'LawClientAccountingLedes',
                actionName: 'DownloadLawClientAccountingLedesFile'
            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile(response.data.fileName.split('.').shift(), response.data.fileAsBase64, 'txt')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
    },

}
</script>

<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
